import React, { ReactNode } from "react"
import { TableSize } from "./types"

// Custom flexRender for rendering cells.
// The original tanstack flexRender somehow causes weird re-mounting issues
// https://github.com/TanStack/table/issues/4794#issuecomment-2809392712
export const flexRenderCustom = <TProps extends object>(
    Comp: ((props: TProps) => ReactNode) | string | undefined,
    props: TProps
): React.ReactNode => {
    if (typeof Comp === "string") {
        return Comp
    }
    return Comp?.(props)
}

export const getFirstColButtonsWidth = (
    hasExpandButton: boolean,
    hasSelectButton: boolean,
    rowDepth: number
): number => {
    const EXTRA_CELL_SPACING = 30
    let total = rowDepth * EXTRA_CELL_SPACING

    if (hasExpandButton) {
        total += EXTRA_CELL_SPACING
    }
    if (hasSelectButton) {
        total += EXTRA_CELL_SPACING
    }

    return total
}

// Depending on table size, we need to adjust cell heights
export const getCellHeightClasses = (size: TableSize): string => {
    switch (size) {
        case "small":
            return "px-3 h-[46px]"
        case "normal":
            return "px-4 h-[54px]"
        case "large":
            return "px-5 h-[62px]"
    }
}

// For more visually pleasing tables, the first and last columns have extra padding
export const getOuterColumnPaddingClasses = (
    size: TableSize
): {
    headerAndFooter: string
    body: string
} => {
    switch (size) {
        case "small":
            return {
                headerAndFooter: "[&>th:first-child]:pl-4 [&>th:last-child]:pr-4",
                body: "[&>td:first-child]:pl-4 [&>td:last-child]:pr-4",
            }
        case "normal":
            return {
                headerAndFooter: "[&>th:first-child]:pl-5 [&>th:last-child]:pr-5",
                body: "[&>td:first-child]:pl-5 [&>td:last-child]:pr-5",
            }
        case "large":
            return {
                headerAndFooter: "[&>th:first-child]:pl-6 [&>th:last-child]:pr-6",
                body: "[&>td:first-child]:pl-6 [&>td:last-child]:pr-6",
            }
    }
}
